import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocalizedText } from "../../utils/hooks/useLocalizedText";
import { Modal, ModalBody } from "reactstrap";
import { TableC } from "../../CommonElements/TableC";

export const DisplayGroupsModal = ({ groups, open, onClose }) => {
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();

  const tableData = useMemo(() => {
    if (!Array.isArray(groups)) {
      return [];
    }
    return groups.filter((group) => Boolean(group));
  }, [groups]);

  // Define columns configuration
  const columns = useMemo(
    () => [
      {
        name: t("GROUP_NAME_COLUMN"),
        key: "name",
        filterable: false,
        render: (value, rowData) =>
          getLocalizedText(rowData?.name_ar || "", rowData?.name_en || ""),
      },
    ],
    [t, getLocalizedText]
  );

  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalBody>
        <TableC
          data={tableData}
          columns={columns}
          loading={false}
          emptyStateTitle={t("NO_GROUPS_FOUND")}
          emptyStateDescription={t("NO_GROUPS_DESCRIPTION")}
          minVisibleColumns={1}
          skeletonCount={3}
        />
      </ModalBody>
    </Modal>
  );
};
